import request from './interceptor'

export function getWithdrawRecords(params = {}) {
  const finalParams = { type: 'personal', ...params }
  return request({
    url: '/v1/finances/withdraw_records',
    method: 'get',
    params: finalParams
  })
}

export function getUserBalanceLogs(params = {}) {
  return request({
    url: '/v1/finances/user_balance_logs',
    method: 'get',
    params
  })
}
